import editForm from './guarantor-entity.form';
import { CustomComponentType, CustomBuilderGroups, LoanRoleType } from '../../../enums';
import { PrimaryRoleRepeaterWidgetVue } from '../primary-role-repeater-widget/primary-role-repeater-widget-vue';

export default class GuarantorEntityWidgetVue extends PrimaryRoleRepeaterWidgetVue {
	static schema(...extend: any) {
		return PrimaryRoleRepeaterWidgetVue.schema(
			{
				label: 'Guarantor',
				type: CustomComponentType.guarantorEntity,
				key: CustomComponentType.guarantorEntity,
				addAnother: 'Add a Guarantor'
			},
			...extend
		);
	}

	static editForm = editForm;

	static get builderInfo() {
		return {
			title: 'Guarantor',
			group: CustomBuilderGroups.widgets,
			weight: 10,
			schema: GuarantorEntityWidgetVue.schema({})
		};
	}

	init() {
		this.roleType = LoanRoleType.Guarantor;

		super.init();
	}
}
